<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="highlight.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-5">
        <app-input
          label="Nome"
          v-model="highlight.name"
          :errors="errors.name"
        ></app-input>
      </div>
      <div class="col-xl-2">
        <app-input
          v-model="highlight.points"
          v-money="moneyConfig"
          :errors="errors.points"
          label="Pontos"
          required
        ></app-input>
      </div>
      <div class="col-xl-5">
        <app-input
          v-model="highlight.url"
          :errors="errors.url"
          label="Link"
        ></app-input>
        <b-checkbox v-model="highlight.new_window"
          >Abrir em nova janela</b-checkbox
        >
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <app-file-picker
          v-model="imageToCrop"
          flag="store-highlight"
          label="Imagem"
          accept="image/*"
          @fileDeleted="onFileDeleted"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="1"
          @croppedImage="onCropperImage"
        ></app-image-cropper>

        <img
          v-if="highlight.image"
          :src="highlight.image"
          alt="Imagem da Campanha"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button type="submit" :disabled="saving" v-app-button>Salvar</button>
      </div>
    </div>
  </form>
</template>

<script>
import StoreHighlightService from '@/services/store-highlights.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import NumberMixin from '@/mixins/NumberMixin';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';

import { required } from 'vuelidate/src/validators';

export default {
  name: 'store-highlights-form',
  props: ['id', 'errors', 'saving'],
  components: { AppImageCropper },
  mixins: [ToastMixin, NumberMixin],
  data: () => {
    return {
      loading: true,
      highlight: {
        active: true,
        name: null,
        points: null,
        image: null,
        url: null,
        new_window: false,
      },
      imageToCrop: null,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
    };
  },
  validations: {
    highlight: {
      name: { required },
      points: { required },
      image: { required },
    },
  },
  methods: {
    loadHighlight(id) {
      StoreHighlightService.getId(id)
        .then(({ data }) => {
          this.highlight = data;
        })
        .catch(() => this.toastfy('Erro ao carregar Destaque.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.highlight,
        points: this.parseDecimalInput(this.highlight.points),
      });
    },
    onCropperImage(value) {
      this.highlight.image = value;
      this.imageToCrop = '';
    },
    onFileDeleted() {
      this.highlight.image = '';
    },
  },
  beforeMount() {
    if (this.id) this.loadHighlight(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 250px;
  height: 250px;
  margin: 20px 0px 5px 0px;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}
</style>
